import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

const isDev = process.env.NODE_ENV === 'development';

export default function AdBanner() {
  const adRef = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (isDev || pushed.current) return;
    if (!process.env.REACT_APP_ADSENSE_CLIENT || !process.env.REACT_APP_ADSENSE_SLOT) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {}
  }, []);

  if (isDev) {
    return (
      <div className="ad-banner-inline ad-banner-mock">
        <span>広告（開発用ダミー）</span>
      </div>
    );
  }

  if (!process.env.REACT_APP_ADSENSE_CLIENT || !process.env.REACT_APP_ADSENSE_SLOT) return null;

  return (
    <div className="ad-banner-inline">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT}
        data-ad-slot={process.env.REACT_APP_ADSENSE_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
